import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as i, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSwitchToCellular",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, r, _, f, a) {
  return i(), d("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--switch-to-cellular"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Switch To Cellular",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.896.646a.5.5 0 0 1 .708 0l1.25 1.25a.5.5 0 0 1 0 .708l-1.25 1.25a.5.5 0 1 1-.708-.708l.397-.396H2.5a.5.5 0 0 1 0-1h1.793l-.397-.396a.5.5 0 0 1 0-.708ZM10.5 2.5a.5.5 0 0 1 .5.5v7.5a.5.5 0 0 1-1 0V3a.5.5 0 0 1 .5-.5Zm-7.896.646a.5.5 0 0 1 0 .708l-.397.396H4a.5.5 0 0 1 0 1H2.207l.397.396a.5.5 0 1 1-.708.708l-1.25-1.25a.5.5 0 0 1 0-.708l1.25-1.25a.5.5 0 0 1 .708 0ZM8 5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5A.5.5 0 0 1 8 5ZM3 9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 3 9Zm2.5-2a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, u);
}
const w = /* @__PURE__ */ s(c, [["render", m]]);
export {
  w as default
};
//# sourceMappingURL=switch-to-cellular.js.map
